"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../../helpers");
exports.MIN_WIDTH_COMBOBOX = helpers_1.FIELD_XXS;
exports.DEFAULT_MAX_WIDTH_COMBOBOX_TOOLTIP = '720px';
//# sourceMappingURL=helpers.js.map